/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/23 10:12
 * @FileName: main.js
 * @LastEditor: 2022/9/23 10:12
 * @Name: main
 */

import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import { post } from '@/framework/http/request'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './project/router'
import store from './framework/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './project/assets/css/style.css'
import './project/assets/css/strength.css'

// vue视频组件
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)

// 分页组件2
import Pagination2 from '@/framework/components/pagination2/pagination2.vue'

Vue.component('el-pagination2', Pagination2)

// import createjs from 'createjs-npm/lib/create';
//
// Vue.use(createjs);

// import $ from 'jquery';
//
// Vue.prototype.$ = $;
//
// import pjax from 'jquery-pjax';
//
// Vue.prototype.$pjax = pjax;
// Vue.prototype.$.pjax = p


// import './project/assets/js/common';
// import './project/assets/js/lib';

import i18n from './project/i18n/i18n.js'

// Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$axios = axios
Vue.prototype.$post = post


if (window.HTMLElement) {
  if (Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1) {
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function() {
        var attributes = this.attributes // 获取节点的所有属性
        var name = []
        var value = [] // 定义两个数组保存属性名和属性值
        var obj = {} // 定义一个空对象
        for (var i = 0; i < attributes.length; i++) {
          // 遍历节点的所有属性
          if (attributes[i].nodeName.slice(0, 5) === 'data-') {
            // 如果属性名的前面5个字符符合"data-"
            // 取出属性名的"data-"的后面的字符串放入name数组中
            name.push(attributes[i].nodeName.slice(5))
            // 取出对应的属性值放入value数组中
            value.push(attributes[i].nodeValue)
          }
        }
        for (var j = 0; j < name.length; j++) {
          // 遍历name和value数组
          obj[name[j]] = value[j] // 将属性名和属性值保存到obj中
        }
        return obj // 返回对象
      }
    })
  }
}

if (!('classList' in document.documentElement)) {
  Object.defineProperty(HTMLElement.prototype, 'classList', {
    get: function() {
      var self = this

      function update(fn) {
        return function(value) {
          var classes = self.className.split(/\s+/g)
          var index = classes.indexOf(value)

          fn(classes, index, value)
          self.className = classes.join(' ')
        }
      }

      return {
        add: update(function(classes, index, value) {
          if (!~index) classes.push(value)
        }),

        remove: update(function(classes, index) {
          if (~index) classes.splice(index, 1)
        }),

        toggle: update(function(classes, index, value) {
          if (~index) {
            classes.splice(index, 1)
          } else {
            classes.push(value)
          }
        }),

        contains: function(value) {
          return !!~self.className.split(/\s+/g).indexOf(value)
        },

        item: function(i) {
          return self.className.split(/\s+/g)[i] || null
        }
      }
    }
  })
}
;
(function() {
  var lastTime = 0
  var vendors = ['ms', 'moz', 'webkit', 'o']
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame']
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime()
      var timeToCall = Math.max(0, 16 - (currTime - lastTime))
      var id = window.setTimeout(function() {
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id)
    }
})()

// 路由进入前
router.beforeEach((to, from, next) => {
  console.log('2222', store.getters)
  NProgress.start()

  // if (store.getters.token) { // 判断是否有token
  //   if (to.path === '/login') {
  //     next({
  //       path: '/'
  //     });
  //   } else {
  //     if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
  //       store.dispatch('GetInfo').then(res => { // 拉取info
  //         const roles = res.data.role;
  //         store.dispatch('GenerateRoutes', {
  //           roles
  //         }).then(() => { // 生成可访问的路由表
  //           router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
  //           next({
  //             ...to,
  //             replace: true
  //           }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
  //         })
  //       }).catch(err => {
  //         console.log(err);
  //       });
  //     } else {
  //       next() //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
  //     }
  //   }
  // } else {
  //   next(); // 否则全部重定向到登录页
  // }
  next()
})
//路由进入后
router.afterEach(() => {
  NProgress.done()
})

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  // We bIM,
  components: {
    App
  },
  template: '<App/>'
})
export default vue




// WEBPACK FOOTER //
// ./src/main.js